import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * @param {string} adminToken 
 * @param {{
*  currentPage: number
*  cardsPerPage: number
* }} data
* @returns {Promise<Response>} 
* @throws {Error}
*/
const GetAuthAccounts = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/auth/accounts?offset=${data.currentPage}&limit=${data.cardsPerPage}`
       const config = { headers: { Authorization: `Bearer ${adminToken}` } }
       const response = await axios.get(url, config)
       const result = (response.status === 200)
       const resultData = response.data.data

       return new Response(result, resultData)
   } catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.HTTP_STATUS_400:
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

/**
 * @param {string} adminToken 
 * @param {{
*  _id: string
* }} data
* @returns {Promise<Response>} 
* @throws {Error}
*/
const DeleteAuthAccounts = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/auth/accounts/${data._id}`
       const config = {
           headers: { Authorization: `Bearer ${adminToken}` }
       }
       const response = await axios.delete(url, config)
       
       const result = (response.status === 200)
       const resultData = response.data.data
       return new Response(result, resultData)
   }
   catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_INVALID_ACCESS:
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

export default {
    GetAuthAccounts,
    DeleteAuthAccounts
}